import React from 'react';
import { useApp } from '@/context/AppContext';
import { Link } from 'react-router-dom';
import { Search, Users2 } from 'lucide-react';
import { Input } from '@/components/ui/input';

export default function DipendentiTeam() {
  const { dipendentiInScope, ferieConfig, saldoOf } = useApp();
  const [q, setQ] = React.useState('');

  const list = dipendentiInScope.filter(d =>
    !q || `${d.nome} ${d.cognome} ${d.reparto}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-green mb-2">Team</div>
        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-stone-900">Dipendenti</h1>
        <p className="mt-2 text-stone-500 text-sm">{list.length} nel tuo scope</p>
      </div>

      <div className="relative max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-stone-400"/>
        <Input placeholder="Cerca…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 rounded-full bg-white border-stone-200"/>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {list.map(d => {
          const cfg = ferieConfig.find(c => c.dipendenteId === d.id);
          const s = saldoOf(d.id);
          return (
            <Link key={d.id} to={`/ferie/${d.id}`} className="rounded-2xl border border-stone-200 bg-white p-4 hover:shadow-md transition-shadow block" data-testid={`team-card-${d.id}`}>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-emerald-50 text-brand-green-hover font-display font-semibold flex items-center justify-center">
                  {d.nome[0]}{d.cognome[0]}
                </div>
                <div className="min-w-0">
                  <div className="font-display font-semibold text-stone-900 tracking-tight truncate">{d.nome} {d.cognome}</div>
                  <div className="text-xs text-stone-500 truncate">{d.reparto} · {cfg.ferieAnnue}g/anno</div>
                </div>
              </div>
              <div className="mt-3 flex items-center justify-between text-xs">
                <span className="text-stone-500">Disponibili</span>
                <span className="font-semibold text-brand-green">{s?.disponibile}g</span>
              </div>
            </Link>
          );
        })}
        {list.length === 0 && (
          <div className="col-span-full text-sm text-stone-500 text-center p-8 border border-dashed rounded-2xl">Nessun risultato.</div>
        )}
      </div>
    </div>
  );
}
